import PropTypes from 'prop-types';
import React from 'react';
import { Head } from '../Head';
import { motion } from 'framer-motion';

export const ContentLayout = ({
  children,
  title,
  titleButton,
  subTitle,
  end = null,
  breadcrumbs,
}) => {
  return (
    <>
      <Head title={title} />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
        className="py-10 px-4"
      >
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl border border-white/20 backdrop-blur-md shadow-2xl bg-white/10 dark:bg-white/5 transition-all duration-300">
            {/* Header Section */}
            <div className="p-2 mb-2">
              {breadcrumbs && <div className="mb-2">{breadcrumbs}</div>}
              <div className="flex flex-col md:flex-row md:items-center justify-between pl-2">
                <div>
                  <div className="flex items-center space-x-4">
                    <h1 className="text-3xl font-bold text-white drop-shadow-sm">
                      {title}
                    </h1>
                    {titleButton}
                  </div>
                  {subTitle && (
                    <p className="mt-2 text-xs text-white/80 dark:text-white/60">
                      {subTitle}
                    </p>
                  )}
                </div>
                {end && <div className="flex-shrink-0">{end}</div>}
              </div>
            </div>
            {/* Divider */}
            <div className="border-t border-white/10 dark:border-white/10" />

            {/* Main Content */}
            <div className="px-6 md:px-4 pb-4 mt-4">
              {children}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

ContentLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  end: PropTypes.node,
  breadcrumbs: PropTypes.node,
};
